const Save = (props) => {
	return <div>Login Form</div>;
};

export default Save;
